var React = require('react');

var style = {
	container: {
		display: 'flex'
	},

	icon: {
		fontSize: 20
	}
}

var PackageType = React.createClass({

	getType: function(pack) {
		var conf;

		switch(pack) {
			case "1":
				conf = {icon: 'icon-box', label: '20x20 cm'};
				break;

			case "2":
				conf = {icon: 'icon-box', label: '40x40 cm'};
				break;

			default:
				conf = {icon: 'icon-envelope-open-o', label: 'Envelope'};
				break;
		}

		return conf;
	},

	render: function() {
		var me = this, pack = me.getType(me.props.type);

		return (
			<div>
				<div style={style.container}>
					<span>
						<i className={pack.icon} style={style.icon}/>
						{pack.label}
					</span>
				</div>
			</div>
		);
	}

});

module.exports = PackageType;


// WEBPACK FOOTER //
// ./src/components/Client/PackageType.jsx